/* Outer-sleeve add-on on the product page: a tick box tied to the main "add to cart" button.
   When something is ticked, the main form's submit is taken over and the product plus the
   ticked companions go into the cart in one request. Nothing ticked = normal Dawn behaviour. */
if (!customElements.get('jc-bundle')) {
  customElements.define(
    'jc-bundle',
    class JcBundle extends HTMLElement {
      connectedCallback() {
        this.checks = Array.prototype.slice.call(this.querySelectorAll('.jc-bundle__check'));
        this.errorEl = this.querySelector('[data-error]');
        this.scope = this.closest('product-info') || document;
        this.productForm = this.scope.querySelector('product-form');
        if (!this.productForm || !this.checks.length) return;
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.checks.forEach((check) => check.addEventListener('change', this.onChange));
        /* capture phase on the wrapper runs before Dawn's own submit handler on the form */
        this.productForm.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        if (this.productForm) this.productForm.removeEventListener('submit', this.onSubmit, true);
      }

      /* Only one pack of outer sleeves per pack of OCG sleeves gets the bundle price,
         so the outer-sleeve rows behave like a single choice. */
      onChange(event) {
        var changed = event.target;
        if (changed.checked && changed.dataset.exclusive) {
          this.checks.forEach((check) => {
            if (check !== changed && check.dataset.exclusive === changed.dataset.exclusive) check.checked = false;
          });
        }
        this.classList.toggle('has-selection', this.selected().length > 0);
        this.showError('');
      }

      selected() {
        return this.checks.filter((check) => check.checked);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      onSubmit(event) {
        var picked = this.selected();
        if (!picked.length) return;
        var form = this.productForm.querySelector('form');
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        var button = this.productForm.querySelector('[type="submit"]');
        if (!idInput || !idInput.value || !button) return;
        event.preventDefault();
        event.stopPropagation();
        if (button.getAttribute('aria-disabled') === 'true') return;

        var quantityInput = this.scope.querySelector('input[name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        var items = [{ id: parseInt(idInput.value, 10), quantity: quantity }].concat(
          picked.map((check) => ({ id: parseInt(check.dataset.variant, 10), quantity: 1 }))
        );
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        var spinner = button.querySelector('.loading__spinner');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        this.showError('');

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              this.showError(data.description || data.message);
              return;
            }
            if (cart && cart.renderContents && data.sections) {
              cart.classList.remove('is-empty');
              cart.renderContents(data);
            } else {
              window.location.href = window.routes.cart_url;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jc-bundle', cartData: data });
            }
          })
          .catch(() => {
            window.location.href = window.routes.cart_url;
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
